import { MuiBadge } from "./MuiBadge";
import { MuiButton } from "./MuiButton";
import { MuiCssBaseline } from "theme/components/MuiCssBaseline";
import { MuiDialog } from "./MuiDialog";
import { MuiDrawer } from "./MuiDrawer";
import { MuiLink } from "./MuiLink";
import { MuiSkeleton } from "theme/components/MuiSkeleton";
import { MuiTab } from "theme/components/MuiTab";
import { MuiTabs } from "theme/components/MuiTabs";
import { MuiTooltip } from "./MuiTooltip";

export const components = {
  MuiCssBaseline,
  MuiTabs,
  MuiTab,
  MuiDrawer,
  MuiLink,
  MuiTooltip,
  MuiDialog,
  MuiButton,
  MuiBadge,
  MuiSkeleton,
};
